module.exports = __webpack_public_path__ + "img/care_details.bf4d69ef.png";